
    /**
    * Check if value is close to target.
    */
    function isNear(val, target, threshold){
        return (Math.abs(val - target) <= threshold);
    }
    module.exports = isNear;




//////////////////
// WEBPACK FOOTER
// ./~/mout/math/isNear.js
// module id = 1618
// module chunks = 0 1 2